import Util from '../../../../forecast-app/shared/util/util';
import {useEffect} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';

const formatCurrency = value => {
	return value || 0;
};

const exportToCsv = (startDate, endDate, viewer) => {
	const currency = viewer.company.currency;
	const projects = viewer.company.financialBasedProjects.edges.map(edge => edge.node);

	if (projects.length > 0) {
		const periodData = projects.map(project => {
			const row = {};

			const monthsData = [];
			for (const period of Object.values(project.aggregatedFinancialNumbers)) {
				const periodStartDate = period.split(',')[0];
				let startMonth = parseInt(periodStartDate.split('-')[1], 10);
				const periodEndDate = period.split(',')[1];
				const endMonth = parseInt(periodEndDate.split('-')[1], 10);
				while (startMonth <= endMonth) {
					monthsData.push(parseFloat(period.split(',')[2]));
					startMonth += 1;
				}
			}

			row['Project ID'] = `P${project.companyProjectId}`;
			row['Project'] = project.name;
			row['January'] = formatCurrency(monthsData[0]);
			row['February'] = formatCurrency(monthsData[1]);
			row['March'] = formatCurrency(monthsData[2]);
			row['April'] = formatCurrency(monthsData[3]);
			row['May'] = formatCurrency(monthsData[4]);
			row['June'] = formatCurrency(monthsData[5]);
			row['July'] = formatCurrency(monthsData[6]);
			row['August'] = formatCurrency(monthsData[7]);
			row['September'] = formatCurrency(monthsData[8]);
			row['October'] = formatCurrency(monthsData[9]);
			row['November'] = formatCurrency(monthsData[10]);
			row['December'] = formatCurrency(monthsData[11]);
			row['Currency'] = currency;

			return row;
		});

		const headerRow = Object.keys(periodData[0]).reduce((map, column) => {
			map[column] = column;
			return map;
		}, {});
		periodData.splice(0, 0, headerRow);

		const csv = Util.JSONToCSV(periodData);
		Util.exportToCSV(csv, `project_portfolio_month_by_month_${startDate.format('YYYY-MM-DD')}-${endDate.format('YYYY-MM-DD')}.csv`);
	}
};

const ProjectPortfolioMonthByMonthDownload = ({viewer, closeModal, startDate, endDate}) => {
	useEffect(() => {
		if (viewer) {
			exportToCsv(startDate, endDate, viewer);
			closeModal();
		}
	}, [viewer]);

	return null;
};

export const projectPortfolioMonthByMonthDownloadQuery = graphql`
	query ProjectPortfolioMonthByMonthDownload_Query(
		$startYear: Int!
		$startMonth: Int!
		$startDay: Int!
		$endYear: Int!
		$endMonth: Int!
		$endDay: Int!
		$searchQuery: TaskSearchQueryType!
		$pageSize: Int!
		$cursor: String
		$selectedSingleValue: FinancialAggregatedNumber!
	) {
		viewer {
			actualPersonId
			component(name: "project_portfolio_month_by_month_project_csv_loader")
			...ProjectPortfolioMonthByMonthDownload_viewer
				@arguments(
					searchQuery: $searchQuery
					startYear: $startYear
					startMonth: $startMonth
					startDay: $startDay
					endYear: $endYear
					endMonth: $endMonth
					endDay: $endDay
					pageSize: $pageSize
					cursor: $cursor
					selectedSingleValue: $selectedSingleValue
				)
		}
	}
`;

export default createFragmentContainer(ProjectPortfolioMonthByMonthDownload, {
	viewer: graphql`
		fragment ProjectPortfolioMonthByMonthDownload_viewer on Viewer
		@argumentDefinitions(
			searchQuery: {type: "TaskSearchQueryType!"}
			startYear: {type: "Int!"}
			startMonth: {type: "Int!"}
			startDay: {type: "Int!"}
			endYear: {type: "Int!"}
			endMonth: {type: "Int!"}
			endDay: {type: "Int!"}
			selectedSingleValue: {type: "FinancialAggregatedNumber!"}
			pageSize: {type: "Int!"}
			cursor: {type: "String"}
		) {
			id
			company {
				currency
				financialBasedProjects(
					searchQuery: $searchQuery
					startYear: $startYear
					startMonth: $startMonth
					startDay: $startDay
					endYear: $endYear
					endMonth: $endMonth
					endDay: $endDay
					aggregateLevel: MONTH
					aggregates: [$selectedSingleValue]
					first: $pageSize
					after: $cursor
				) {
					edges {
						node {
							id
							companyProjectId
							name
							fullAccessToProject
							projectColor
							useBaseline
							status
							baselineWinChance
							aggregatedFinancialNumbers(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: MONTH, aggregates: [$selectedSingleValue])
						}
					}
				}
			}
		}
	`,
});
